import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import ScreenshotButton from './ScreenshotButton';

// SVG icons as components
const HomeIcon: React.FC<{ color: string }> = ({ color }) => (
  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 3L4 9v12h5v-7h6v7h5V9l-8-6z" fill={color} />
  </svg>
);

const SettingsIcon: React.FC<{ color: string }> = ({ color }) => (
  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.07.62-.07.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z" fill={color} />
  </svg>
);

const Navigation: React.FC = () => {
  const { user } = useAuth();
  const { theme } = useTheme();
  const location = useLocation();


  const navStyle = {
    backgroundColor: theme.colors.PRIMARY,
    padding: theme.spacing.MEDIUM,
    color: theme.colors.WHITE,
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  };

  const linkStyle = {
    color: theme.colors.WHITE,
    textDecoration: 'none',
    padding: theme.spacing.SMALL,
    margin: `0 ${theme.spacing.SMALL}px`,
    borderRadius: '4px',
    transition: 'background-color 0.2s',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const activeLinkStyle = {
    ...linkStyle,
    backgroundColor: 'rgba(255,255,255,0.2)',
  };


  return (
    <nav style={navStyle}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          maxWidth: '1200px',
          margin: '0 auto',
        }}
      >
        {/* Left: Home icon */}
        <div style={{ minWidth: 48, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flex: '0 0 auto' }}>
          {user && (
            <Link
              to="/dashboard"
              style={
                location.pathname === '/dashboard'
                  ? activeLinkStyle
                  : linkStyle
              }
              title="Home"
            >
              <HomeIcon color={theme.colors.WHITE} />
            </Link>
          )}
        </div>

        {/* Center: TEST ENVIRONMENT label if present */}
        {/* <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <EnvironmentIndicator />
        </div> */}

        {/* Right: Settings and Screenshot icons */}
        <div style={{ minWidth: 48, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flex: '0 0 auto', gap: theme.spacing.SMALL }}>
          {user && (
            <>
              <ScreenshotButton />
              <Link
                to="/profile"
                style={
                  location.pathname === '/profile' ? activeLinkStyle : linkStyle
                }
                title="Settings"
              >
                <SettingsIcon color={theme.colors.WHITE} />
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
